import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { DocumentService } from '@src/core/services';
import { ViewMode } from '@src/models';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { validateFileExtension } from '@src/app/shared/base-photo';

@Component({
  selector: 'app-field-file',
  templateUrl: './field-file.component.html',
  styleUrls: ['./field-file.component.scss', '../styles/field-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldFileComponent extends BaseResizableComponent implements OnChanges {
  private readonly documentService = inject(DocumentService);

  @Input() mode?: ViewMode = 'view';
  @Input() fileName?: string;
  @Input() fileId?: string | null;
  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';

  fileType: 'photo' | 'document' = 'document';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fileId && this.fileId) {
      this.documentService
        .getDocumentInfo(this.fileId)
        .pipe(takeUntil(this.destroyed$$))
        .subscribe(documentInfo => {
          if (validateFileExtension(documentInfo.fileName)) {
            this.fileType = 'photo';
          }

          this.cdr.markForCheck();
        });
    }
  }

  downloadDocument(): void {
    if (!this.fileId) return;

    this.documentService.downloadDocumentById(this.fileId);
  }
}
